import { Link } from 'gatsby';
import React from 'react';
import LogoImage from '../../../../../../static/logo-default-500x120.png';
import i18n from '../../../../../utils/i18n';

const Logo = () => (
    <Link to={i18n.language === 'es-US' ? '/es' : '/'}>
        <img alt={'trades.org logo'} className={'w-24 resize-none'} src={LogoImage} />
    </Link>
);

export default Logo;
